export default {
  title: 'Menü Importieren',
  master_title: 'Marken-Modus - Menü importieren',
  buttons: {
    import: 'Importieren',
  },
  toasts: {
    import: {
      pending:
        '⏳Da der Import manchmal langsam sein kann, führen wir ihn im Hintergrund durch. Bitte überprüfen Sie das Restaurant-Menü in ein paar Minuten.',
    },
  },
};
